/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Authentication layout components
import IllustrationLayout from "layouts/authentication/components/IllustrationLayout";

import { AuthContext } from "context";
import AuthService from "services/auth-service";

// registration steps
import Step1 from "./step1";
// import Step2 from "./step2";
// import Step3 from "./step3";
// import Step4 from "./step4";
// import Step5 from "./step5";
// import Step6 from "./step6";

// Images
import bgImage from "assets/images/illustrations/illustration-reset.jpg";
import poweredByImage from "assets/images/quantuniversity-llc-logo.jpg";

function Register() {
  const navigate = useNavigate();
  const location = useLocation();
  // Extract redirect URL from query params
  const params = new URLSearchParams(location.search);
  const redirectTo = params.get("redirect") || "/home-page"; // Default to home if no redirect
  const authContext = useContext(AuthContext);
  const [profileDetails, setProfileDetails] = useState({
    id: "",
    name: "",
    email: "",
    profile_image: "",
    linkedin_profile_id: "",
    summary: "",
    headline: "",
    skills: "",
    preferred_jobs: [],
    preferred_locations: [],
    education: [],
    experience: [],
    location_name: "",
    resume_location: "",
    jobs_visited: [],
    available_courses: [],
  });

  const [auth, setAuth] = useState({
    access_token: "",
    refresh_token: "",
  });

  const [inputs, setInputs] = useState({
    name: "",
    email: "",
    password: "",
    confirmPass: "",
    linkedin_profile_id: "",
    agree: false,
  });

  const [errors, setErrors] = useState({
    nameError: false,
    emailError: false,
    passwordError: false,
    confirmPassError: false,
    agreeError: false,
    linkedin_profile_taken: false,
    emailTaken: false,
    endError: "",
  });

  const changeHandler = (e) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      nameError: false,
      emailError: false,
      passwordError: false,
      confirmPassError: false,
      agreeError: false,
      linkedin_profile_taken: false,
      emailTaken: false,
      endError: "",
    });
  };

  const checkLinkedinProfile = async (linkedin_profile_id) => {
    // check regex for linnkedin profile id https://www.linkedin.com/in/<id>
    const linkedinProfileRegex =
      /^https:\/\/www.linkedin.com\/in\/[a-zA-Z0-9-]+$/;
    if (!linkedin_profile_id.match(linkedinProfileRegex)) {
      setErrors({ ...errors, linkedin_profile_taken: true });
      return false;
    }
    return true;
  };

  // const [currentStep, setCurrentStep] = useState(1);

  // const nextStepHandler = (nextStep) => {
  //   setCurrentStep(nextStep);
  // };

  const submitHandler = async (e) => {
    e.preventDefault();
    const mailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (inputs.name.trim().length === 0) {
      setErrors({ ...errors, nameError: true });
      return;
    }

    if (
      inputs.email.trim().length === 0 ||
      !inputs.email.trim().match(mailFormat)
    ) {
      setErrors({ ...errors, emailError: true });
      return;
    }

    if (inputs.password.trim().length < 8) {
      setErrors({ ...errors, passwordError: true });
      return;
    }

    if (inputs.confirmPass.trim() !== inputs.password.trim()) {
      setErrors({ ...errors, confirmPassError: true });
      return;
    }

    if (inputs.agree === false) {
      setErrors({ ...errors, agreeError: true });
      return;
    }

    if (inputs.linkedin_profile_id.trim().length === 0) {
      setErrors({
        ...errors,
        endError: "Linkedin Profile ID can not be empty",
      });
      return;
    }

    if (!(await checkLinkedinProfile(inputs.linkedin_profile_id))) {
      setErrors({
        ...errors,
        endError:
          "Linkedin Profile ID must be a valid URL. Example: https://www.linkedin.com/in/<id>",
      });
      return;
    }

    // here will be the post action to add a user to the db
    const newUser = {
      name: inputs.name,
      email: inputs.email,
      password: inputs.password,
      linkedin_profile_id: inputs.linkedin_profile_id,
    };
    const myData = {
      data: {
        type: "users",
        attributes: { ...newUser, password_confirmation: newUser.password },
      },
    };

    try {
      const response = await AuthService.register(myData);
      authContext.login(response.access_token, response.refresh_token, "/home-page");
    } catch (err) {
      setErrors({ ...errors, endError: err.message });
      return null;
    }

    setInputs({
      name: "",
      email: "",
      password: "",
      confirmPass: "",
      linkedin_profile_id: "",
      agree: false,
    });

    setErrors({
      nameError: false,
      emailError: false,
      passwordError: false,
      confirmPassError: false,
      agreeError: false,
      linkedin_profile_taken: false,
      emailTaken: false,
      endError: "",
    });
  };

  return (
    <IllustrationLayout
      title="Sign Up"
      illustration={bgImage}
      poweredBy={poweredByImage}
    >
      <Step1
        // nextStepHandler={nextStepHandler}
        setAuth={setAuth}
        auth={auth}
        profileDetails={profileDetails}
        setProfileDetails={setProfileDetails}
        params={params}
      />
    </IllustrationLayout>
  );
}

export default Register;
